import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import MarqueeStrip from "../components/sections/Marquee";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Portfolio from "../components/sections/Portfolio";
import ExploreTabs from "../components/sections/ExploreTabs";
import Stats from "../components/sections/Stats";
import Pricing from "../components/sections/Pricing";
import Contact from "../components/sections/Contact";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative bg-gk-black">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Services />
        <Stats />
        <WhyChooseUs />
        <Portfolio />
        <ExploreTabs />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
